var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceMobileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27V5C24 3.89543 23.1046 3 22 3L10 3C8.89543 3 8 3.89543 8 5L8 27C8 28.1046 8.89543 29 10 29H22C23.1046 29 24 28.1046 24 27Z",
    stroke: "#8F9195",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.75C16.6904 8.75 17.25 8.19036 17.25 7.5C17.25 6.80964 16.6904 6.25 16 6.25C15.3096 6.25 14.75 6.80964 14.75 7.5C14.75 8.19036 15.3096 8.75 16 8.75Z",
    fill: "#8F9195"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMobileCamera);
export default __webpack_public_path__ + "static/media/DeviceMobileCamera.b22946d1f5ec88a01b0e20015744a42d.svg";
export { ForwardRef as ReactComponent };